import React, { createContext, useContext, useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { io, Socket } from "socket.io-client";
import { RootState } from "@/store";
 
// Create the context
const SocketContext = createContext<Socket | null>(null);
 
const socketURL = import.meta.env.VITE_SOCKET_BASE_URL; // Replace with your server URL
 
// SocketProvider component to wrap the application
export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [socket, setSocket] = useState<Socket | null>(null);
    const user = useSelector(
      (root: RootState) => root.rootReducer.userReducer.user
    );
 
    
 
 
 
 
  // useEffect(() => {
  //   const socketInstance = io(socketURL, {
  //     transports: ["websocket"], // Ensure using WebSocket for better performance
  //   });
 
  //   socketInstance.on("connect", () => {
  //     console.log(countryName,"line 31")
  //     console.log("Connection established");
  //     socketInstance.emit("setCountry", countryName);
  //   });
 
  //   // Store the socket instance when connected
  //   setSocket(socketInstance);
 
  //   // Clean up the socket connection on unmount
  //   return () => {
  //     socketInstance.disconnect();
  //   };
  // }, []);
 
  useEffect(() => {
    const socketInstance = io(socketURL, {
      transports: ["websocket"],
    });
 
    setSocket(socketInstance);
 
    return () => {
      socketInstance.disconnect();
    };
  }, []);
 
  useEffect(() => {
    if (socket) {
      console.log(user,"user details",user?.company_id?.[0])
      const countryName =user?.countryName;
      const crmUserId =user?.crmUserId;
      const companyId =user?.company_id?.[0];
      console.log(countryName,"country form the user profile")
      console.log(countryName, "countryCOde");
      socket.emit("setCountry", countryName);
      socket.emit("setCrmUserId", crmUserId);
      socket.emit("setCompanyId", companyId);
      socket.emit("setUserInfo", user);
      socket.on("connect", () => {
        console.log("Connected to the server");
        socket.emit("setCountry", countryName);
        socket.emit("setCrmUserId", crmUserId);
        socket.emit("setCompanyId", companyId);
        socket.emit("setUserInfo", user);
      });
    }
  }, [socket,user]);
 
 
  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};
 
// Custom hook to use socket
export const useSocket = (): Socket | null => {
  const socket = useContext(SocketContext);
  if (!socket) {
    // throw new Error("Socket not initialized!");
    console.log("socket connection failed!");
  }
  return socket;
};
 
 